// @module StellarGrade.ST_Facets.FacetsBrowseCategoryCell.View
define('StellarGrade.ST_Facets.Facets.Browse.View', ['Facets.Browse.View', 'stellargrade_st_facets_facetsbrowse.tpl', 'underscore', 'jQuery'], function (
    FacetsBrowseView,
    stellargrade_st_facets_FacetsBrowse_tpl,
    _,
    $,
) {
    'use strict';

    return {
        loadModule: function () {
            _.extend(FacetsBrowseView.prototype, {
                template: stellargrade_st_facets_FacetsBrowse_tpl,
                getContext: _.wrap(FacetsBrowseView.prototype.getContext, function wrapper(fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var category = this.model.get('category');
                    var addtohead = category.get('addtohead');

                    context.faqItems = parseQandA(addtohead);
                    if (context.faqItems.length > 0) {
                        context.hasFAQ = true;
                    }
                    return context;
                }),
            });
        },
    };
    function parseQandA(text) {
        if (!text) return [];
        var items = [];

        //   Q: question text?
        //   A: answer text
        var re = /Q:\s*([\s\S]+?)\s*A:\s*([\s\S]+?)(?=\s*Q:|$)/gi;
        var match, index = 0;

        while ((match = re.exec(text)) !== null) {
            var question = match[1].trim();
            var answer = match[2].trim();

            if (question && answer) {
                items.push({
                    number: String(++index).padStart(2, '0'),
                    question: question,
                    answer: answer,
                });
            }
        }

        return items;
    }
});
